export enum InfluenceType {
    ANY = 'any',
    POST = 'post',
    PRE = 'pre'
}
